export default __webpack_public_path__ + "static/assets/cc56ddc24a1760b83327e5c4a5706377.png";